const requiredRule = [
    v => !!v || 'Данное поле обязательно',
]

const oneOfTwoRequired = [
    v => console.log(v)
]

export {requiredRule, oneOfTwoRequired}